/* @flow */

export { ZalgoPromise } from './promise';



// WEBPACK FOOTER //
// webpack://paypal/node_modules/zalgo-promise/src/index.js